import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { HasMenuGuard } from 'src/app/core/guards/has-menu.guard';
import { DashboardComponent } from './dashboards/dashboard/dashboard.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch:'full'},
  { path: 'dashboard', component: DashboardComponent },
  { path: 'dashboards', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)},
  { path: 'case', loadChildren: () => import('./case/case.module').then(m => m.CaseModule)},
  { path: 'label-printing', loadChildren: () => import('./label-printing/label-printing.module').then(m => m.LabelPrintingModule)},
  { path: 'operations', loadChildren: () => import ('./operations/operations.module').then(m=>m.OperationsModule)},
  { path: 'exchange', loadChildren: () => import('./exchange/exchange.module').then(m => m.ExchangeModule)},
  { path: 'retail', loadChildren: () => import('./retail/retail.module').then(m => m.RetailModule), },
  { path: 'manufacture', loadChildren: () => import('./manufacture/manufacture.module').then(m => m.ManufactureModule)},
  { path: 'monitoring', loadChildren: () => import('./monitoring/monitoring.module').then(m => m.MonitoringModule)},
  { path: 'deleted-data', loadChildren: () => import('./deleted-data/deleted-data.module').then(m => m.DeletedDataModule)},
  { path: 'data-transfer', loadChildren: () => import('./data-transfer/data-transfer.module').then(m => m.DataTransferModule)},
  { path: 'specifications', loadChildren: () => import('./specifications/specifications.module').then(m => m.SpecificationsModule)},
  { path: 'marketplace', loadChildren: () => import('./marketplace/marketplace.module').then(m => m.MarketplaceModule)},
  {
    path: 'ai',
    loadChildren: () => import('./ai/ai.module').then((m) => m.MarketplaceAiModule)
  },
  {
    path: 'tokens',
    loadChildren: () => import('./tokens/tokens.module').then(m => m.TokensModule)
  },
  {
    path: 'ecommerce-orders',
    loadChildren: () => import('./ecommerce-orders/ecommerce-orders.module').then(m => m.EcommerceOrdersModule)
  },
  {
    path: 'ecommerce-admin',
    loadChildren: () => import('./ecommerce-admin/ecommerce-admin.module').then(m => m.EcommerceAdminModule)
  },
  {
    path: 'accounting',
    loadChildren: () => import('./accounting/accounting.module').then(m => m.AccountingModule)
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
